
import { useNavigate } from 'react-router';
import { HERO_IMAGE } from '../constants';
import img1 from '../images/kits/k3.jpeg';
const Hero=() => {
  let nav=useNavigate();
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background with parallax effect */}
      <div className="absolute inset-0 z-0">
        <img 
          src={HERO_IMAGE} 
          alt="Hero background" 
          className="w-full h-full object-cover opacity-60 scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/20"></div>
      </div>
      <div className="container mx-auto px-4 md:px-8 relative z-10 pt-20">
        <div className="max-w-3xl">
          <h2 className="text-gold font-bold tracking-[0.3em] uppercase mb-4 animate-fadeIn" style={{ animationDelay: '0.2s' }}>
            शुद्ध आयुर्वेदिक उत्पाद
          </h2>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-6 leading-tight animate-fadeIn" style={{ animationDelay: '0.4s' }}>
            <span className="text-gold italic">वीर्य शरीर का राजा है </span>
          </h1>
          <p className="text-lg text-justify text-gray-300 mb-8 max-w-xl animate-fadeIn leading-relaxed" style={{ animationDelay: '0.6s' }}>
            आयुर्वेद एवं योग के दृष्टिकोण से ब्रह्मचर्य और सेक्स पावर एक ही ऊर्जा के दो पक्ष हैं। आयुर्वेद के अनुसार शरीर की मूल जीवन शक्ति शुक्र धातु में निहित होती है, जो उचित आहार, दिनचर्या और संयम से पुष्ट होती है। अत्यधिक भोग, मानसिक तनाव और अनियमित जीवनशैली से इस धातु का क्षय होता है, जिससे शारीरिक दुर्बलता, मानसिक अस्थिरता और ऊर्जा की कमी उत्पन्न होती है। योग दर्शन में ब्रह्मचर्य का अर्थ केवल यौन संयम नहीं, बल्कि विचारों, इंद्रियों और इच्छाओं का नियंत्रण है, जिससे यौन ऊर्जा का संरक्षण होकर वह ओज और तेज में परिवर्तित होती है। प्राणायाम, ध्यान, आसन और सात्त्विक आहार से यह ऊर्जा संतुलित रहती है और व्यक्ति की शारीरिक क्षमता, सहनशक्ति, मानसिक स्पष्टता तथा आत्मविश्वास में वृद्धि होती है। इस प्रकार आयुर्वेद और योग दोनों यह मानते हैं कि संयमित जीवन और ब्रह्मचर्य के पालन से सेक्स पावर कमजोर नहीं होती, बल्कि स्थायी, नियंत्रित और स्वास्थ्यवर्धक रूप में विकसित होती है।
          </p>
          
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6 animate-fadeIn" style={{ animationDelay: '0.8s' }}>
            <button onClick={()=>{nav("/products")}} className="px-10 py-4 bg-gold text-black font-bold uppercase tracking-widest hover:bg-white transition-all transform hover:-translate-y-1">
              Explore Products
            </button>
            <button onClick={()=>{nav("/story")}} className="px-10 py-4 border border-white/20 text-white font-bold uppercase tracking-widest hover:bg-white/10 transition-all backdrop-blur-sm">
              Our Story
            </button>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 md:px-8 relative z-10 pt-20">
        <div className="max-w-3xl">
          <img src={img1} style={{height:"400px"}} />
        </div>
      </div>
      {/* Trust Badges */}
      <div className="absolute bottom-10 left-0 right-0 z-10 hidden md:block">
        <div className="container mx-auto px-8">
          <div className="flex justify-between items-center border-t border-white/10 pt-8 text-gray-400 text-xs tracking-widest uppercase">
            <div className="flex items-center space-x-2">
              <i className="fas fa-leaf text-gold"></i>
              <span>100% Herbal</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="fas fa-flask text-gold"></i>
              <span>Lab Tested</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="fas fa-award text-gold"></i>
              <span>Premium Quality</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="fas fa-truck text-gold"></i>
              <span>Discreet Shipping</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
